module.exports = __webpack_public_path__ + "static/media/img151.a350d338.jpg";